import { useUser } from '~/stores/user/user'

export default defineNuxtRouteMiddleware(async () => {
  const { state: user, actions: userActions, getters: userGetters } = useUser()

  if (userGetters.isLoggedIn) {
    return
  }

  try {
    await userActions.getTokens()
  } catch (error) {
    return navigateTo('/login')
  }

  await userActions.getMe()

  if (!user.value) {
    return navigateTo('/login')
  }
})
